import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuardService implements CanActivate {
  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot
  ):
    | boolean
    | import("@angular/router").UrlTree
    | import("rxjs").Observable<boolean | import("@angular/router").UrlTree>
    | Promise<boolean | import("@angular/router").UrlTree> {
    return this.authService.authDataSubject.pipe(
      take(1),
      map(usersRes => {
        const isAuth = !!usersRes;
        console.log(isAuth + "isAuth" + usersRes);

        if (isAuth) {
          this.router.navigate(["/pas"]);
return false
        } else {
          return true
        }
      })
    );
  }

  constructor(private authService: AuthService, private router: Router) {}
  


}
